import { render, staticRenderFns } from "./GlobalTopBanner.vue?vue&type=template&id=60454a78&scoped=true"
import script from "./GlobalTopBanner.vue?vue&type=script&lang=js"
export * from "./GlobalTopBanner.vue?vue&type=script&lang=js"
import style0 from "./GlobalTopBanner.vue?vue&type=style&index=0&id=60454a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60454a78",
  null
  
)

export default component.exports